import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import Dashboard from "./Pages/Dashboard";
import { Route, Routes } from "react-router-dom";
import Directsponsor from "./Pages/DirectsponsorList";
import Teamlist from "./Pages/teamlist";
import SponsorTree from "./Pages/sponsortree";
import Buypackage from "./Pages/buypackage";
import Incomes from "./Pages/incomes";
import Passbook from "./Pages/passbook";
import Transactions from "./Pages/transactions";
import Deposit from "./Pages/deposit";
import Transfer from "./Pages/transfer";
import Withdraw from "./Pages/withdraw";
import Convert from "./Pages/convert";
import Contactus from "./Pages/contactus";
import Profile from "./Pages/profile";
import Changepassword from "./Pages/changepassword";
import ROIincome from "./Pages/roiincome";
import ROIDincome from "./Pages/roidincome";
import Rankingincome from "./Pages/rankingincome";
import StockTree from "./Pages/StockTree";
import ROIDincomeReport from "./Pages/roidincomereport";
import KYC from "./Pages/KYC";
import FAQ from "./Pages/Faq";
import { createContext, useState } from "react";
import ThemeContext from "./themecontext";
import DocumentUpload from "./Pages/documentupload";


function App() {
  const [theme, setTheme] = useState('light');
  return (
    <ThemeContext.Provider  value={{ theme, setTheme }}>
    <div className="wrapper" style={{minHeight:"100vh"}}>
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <Routes>
            <Route path="/home" element={<Dashboard />} />
            <Route path="/directsponsor" element={<Directsponsor />} />
            <Route path="/teamlist" element={<Teamlist />} />
            <Route path="/treeview" element={<StockTree />} />
            <Route path="/vtreeview" element={<SponsorTree />} />
            <Route path="/activation" element={<Buypackage />} />
            {/* <Route path="/income" element={<Incomes />} /> */}
            <Route path="/income/:type" element={<ROIDincome />} />
            <Route path="/incomereport" element={<ROIDincomeReport />} />
            <Route path="/incomereport/:cdate" element={<ROIDincomeReport />} />
            <Route path="/incomereport/:cdate/:mode" element={<ROIDincomeReport />} />
            <Route path="/passbook" element={<Passbook />} />
            <Route path="/transactions/:type" element={<Transactions />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/transfer" element={<Transfer />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/convert" element={<Convert />} />
            <Route path="/contactus" element={<Contactus />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Changepassword />} />
            <Route path="/roiincome" element={<ROIincome />} />
            <Route path="/roidincome" element={<ROIDincome />} />
            <Route path="/rankingincome" element={<Rankingincome />} />
            <Route path="/kyc" element={<KYC />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/documentbank" element={<DocumentUpload />} />
          </Routes>
        </div>
      </div>

      <Footer />


      <div className="control-sidebar-bg"></div>

    </div>
    </ThemeContext.Provider>
  );
}

export default App;
